


export function listPage(data, current_page) {
  let pageCount = data.Data.pageCount;
  if (
    pageCount <= current_page &&
    data.Data.model.length == 0
  ) {
    return pageCount;
  }
}

export function isDef(val) {
  return val !== null && val !== undefined
}

function toNum3(colorStr) {
  if (colorStr.length === 3) {
    colorStr = colorStr[0] + colorStr[0] + colorStr[1] + colorStr[1] + colorStr[2] + colorStr[2]
  }
  let r = parseInt(colorStr.slice(0, 2), 16)
  let g = parseInt(colorStr.slice(2, 4), 16)
  let b = parseInt(colorStr.slice(4, 6), 16)
  return [r, g, b]
}

export function lighten(colorStr, rate) {
  let nums = toNum3(colorStr.slice(1))
  let r = nums[0]
  let g = nums[1]
  let b = nums[2]
  if (rate === 0) {
    return '#' + [r.toString(16), g.toString(16), b.toString(16)].join('')
  } else {
    r += Math.round(rate * (255 - r))
    g += Math.round(rate * (255 - g))
    b += Math.round(rate * (255 - b))
    r = r.toString(16)
    g = g.toString(16)
    b = b.toString(16)
    return '#' + r + g + b
  }
}

// 取出2个数组不同元素
export function getArrDifference(arr1, arr2) {
  return arr1.concat(arr2).filter(function (v, i, arr) {
    return arr.indexOf(v) === arr.lastIndexOf(v);
  });
}
// 取出2个数组相同元素
export function getArrEqual(arr1, arr2) {
  let newArr = [];
  for (let i = 0; i < arr2.length; i++) {
    for (let j = 0; j < arr1.length; j++) {
      if (arr1[j] === arr2[i]) {
        newArr.push(arr1[j]);
      }
    }
  }
  return newArr;
}
export function secondToStr(second) {
  if (second <= 1) {
    return Math.round(second * 1000) + "ms"
  } else if (second > 1 && second < 60) {
    return Math.round(second) + "s"
  } else {
    let m = second / 60
    let s = second % 60
    return Math.round(m) + "mins" + Math.round(s) + "s"
  }
}
//yyyy-mm-dd hh:mm:ss
export function dateFormat(timestamp) {
  var zero = function (value) {
    if (value < 10) {
      return '0' + value;
    }
    return value;
  };
  var myDate = timestamp ? new Date(timestamp) : new Date();
  var year = myDate.getFullYear();
  var month = zero(myDate.getMonth() + 1);
  var day = zero(myDate.getDate());
  var hour = zero(myDate.getHours());
  var minite = zero(myDate.getMinutes());
  var second = zero(myDate.getSeconds());
  return year + "-" + month + "-" + day + " " + hour + ":" + minite + ":" + second;
};
//yyyy-mm-dd
export function dateFormat1(timestamp) {
  var zero = function (value) {
    if (value < 10) {
      return '0' + value;
    }
    return value;
  };
  var myDate = timestamp ? new Date(timestamp) : new Date();
  var year = myDate.getFullYear();
  var month = zero(myDate.getMonth() + 1);
  var day = zero(myDate.getDate());
  return year + "-" + month + "-" + day;
};
//yyyy
export function dateFormat2(timestamp) {
  var myDate = timestamp ? new Date(timestamp) : new Date();
  var year = myDate.getFullYear();
  return year;
};
//yyyy-mm
export function dateFormat3(timestamp) {
  if (timestamp == "" || timestamp == 0) return "";
  var zero = function (value) {
    if (value < 10) {
      return '0' + value;
    }
    return value;
  };
  var myDate = timestamp ? new Date(timestamp) : new Date();
  var year = myDate.getFullYear();
  var month = zero(myDate.getMonth() + 1);
  return year + "-" + month;
};

export function showErrorMsg(vue, msg, duration) {
  vue.$message({
    message: msg,
    type: "error",
    duration: duration,
  });
}


// WEBPACK FOOTER //
// ./src/utils/utils.js